const statuses = {
    403: 'Запрещено',
    413: 'Request Entity Too Large'
};

const apiFetch = (url, config) => {
    if (!config.headers) {
        config.headers = {};
    }

    config.headers["Accept"] = "application/json";

    return new Promise((res, rej) => {
        fetch(url, config)
            .then(response => {
                if (response.ok) {
                    return response;
                } else {
                    if (response.status == 401) {
                        window.showAuthPopup();
                        throw new Error('not-auth');
                    } else {
                        throw new Error(response.status);
                    }
                }
            })
            .then(response => {
                res(response.json());
            })
            .catch(error => {
                if (error.name === "AbortError") {
                    // ignore
                }
                else {
                    const message = statuses[error.message] || 'Что-то пошло не так';
                    rej(message);
                }
            });
    });
};

export { apiFetch };